import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

/**
 * The wrong-building guard's amber hint: the pin sits on a different
 * registered title than the site address. A hint, not a blocker — corner
 * plots, flying freeholds and stale INSPIRE extracts all produce legitimate
 * cross-title pins, so the user stays in charge; we just make them look twice
 * before an analysis runs on a neighbour's roof.
 */
const ParcelMismatchHint: FC = () => (
  <div className="flex items-start gap-2 rounded-md border border-yellow-200 bg-yellow-50/60 p-3">
    <UntitledIcon
      name="alert-triangle.3"
      className="mt-0.5 h-5 w-5 flex-shrink-0 text-yellow-600"
    />
    <p className="m-0 text-sm">
      The pin is on a different title than the address. Double-check it&apos;s
      the right property.
    </p>
  </div>
);

export default ParcelMismatchHint;
